'use client';

import { useState } from 'react';
import { useRouter } from 'next/navigation';

import { useTranslations } from 'use-intl';

import { LeaveFormAlertDialog } from '../leaveFormAlertDialog/LeaveFormAlertDialog';
import { LEAVE_ALERT_SS_KEY } from '../../../../../../configs/app.config';
import { Button } from '../../../../../../components/button/Button';

export const CheckReportButtonClient = () => {
  const t = useTranslations();
  const [showDialog, setShowDialog] = useState<boolean>(false);
  const router = useRouter();

  return (
    <>
      <Button
        handleClick={() => {
          if (sessionStorage.getItem(LEAVE_ALERT_SS_KEY) === 'true') {
            setShowDialog(true);
          } else {
            router.push('check-report');
          }
        }}
      >
        {t('labels.checkReport')}
      </Button>

      {showDialog && (
        <LeaveFormAlertDialog
          handleClose={() => {
            setShowDialog(false);
          }}
          handleAccept={() => {
            setShowDialog(false);

            router.push('check-report');
          }}
        />
      )}
    </>
  );
};
